module.exports = __webpack_public_path__ + "02_short_brown.e45ccbbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_short_brown.png
// module id = 0B28
// module chunks = 0